import { render, staticRenderFns } from "./jyj_jiuye.vue?vue&type=template&id=9edbfec0&scoped=true"
import script from "./jyj_jiuye.vue?vue&type=script&lang=js"
export * from "./jyj_jiuye.vue?vue&type=script&lang=js"
import style0 from "./jyj_jiuye.vue?vue&type=style&index=0&id=9edbfec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbfec0",
  null
  
)

export default component.exports